import React from 'react';
import { formatNumberByLanguage } from '../../../../utils/usefulFunctions';
import Title from '../../../components/Title';
import Icon from '../../../../muiComponents/Icon';
import useTranslate from '../../../../customHooks/useTranslate';
import useLanguage from '../../../../customHooks/useLanguage';

const BookingTextStatistics = ({ bookingsData, currency }) => {
    const translate = useTranslate();
    const language = useLanguage();
    const averageStay =
        bookingsData
            .filter(item => item.commitedAverageStay)
            .reduce((acc, obj) => {
                return acc + obj.commitedAverageStay;
            }, 0) /
            bookingsData.filter(item => item.commitedAverageStay).length || 0;

    return (
        <div className='booking-data__container'>
            <div className='flex gap-5'>
                <Icon iconName='Calculate' className='text-primary-400' />
                <Title>{`${translate('total_bookings')}: `}</Title>
                <p>
                    {formatNumberByLanguage(
                        bookingsData.reduce((acc, obj) => {
                            return acc + obj.commitedBookingCount;
                        }, 0),
                        language
                    )}
                </p>
            </div>
            <div className='flex gap-5'>
                <Icon
                    iconName='FormatAlignCenter'
                    className='text-primary-400'
                />
                <Title>{`${translate('average_stay')}: `}</Title>
                <p>
                    {`${formatNumberByLanguage(
                        averageStay,
                        language
                    )} ${translate('days')}`}
                </p>
            </div>
            <div className='flex gap-5'>
                <Icon iconName='Payments' className='text-primary-400' />
                <Title>{`${translate('revenue')}: `}</Title>
                <p>
                    {`${formatNumberByLanguage(
                        bookingsData
                            .filter(item => item.revenue)
                            .reduce((acc, obj) => {
                                return acc + obj.revenue;
                            }, 0),
                        language
                    )} ${currency}`}
                </p>
            </div>
        </div>
    );
};

export default BookingTextStatistics;
